export enum QueryKeys {
  Class = "class",
  Waivers = "waivers",
  Seasons = "seasons",
  Classes = "classes",
  UserGet = "user-get",
  Students = "students",
  Locations = "locations",
  ContactRecipients = "contact-recipients",
  CommunicationSettings = "communication-settings",
  UserStudentsGet = "user-students-get",
  FamilyContactsGet = "family-contacts-get",
  ClassesEnrollmentsByStudentId = "classes-enrollments-by-student-id",
  StudentAvailableClasses = "student-available-classes",
  UserFindByEmail = "user-find-by-email",
  UsersScrollGet = "users-scroll-get",
  UsersByRoleGet = "users-by-role-get",
  Teachers = "teachers",
  Teacher = "teacher",
  /** Auth user → appointment `teacherId` (email lookup). */
  TeacherProfileId = "teacher-profile-id",
  AppointmentHours = "appointment-hours",
  SpecialHours = "special-hours",
  AppointmentExclusions = "appointment-exclusions",
  Appointments = "appointments",
  AppointmentTypes = "appointment-types",
  ClassRooms = "classrooms",
  AppointmentAvailability = "appointment-availability",
  AppointmentBookings = "appointment-bookings",
  Tenant = "tenant",
  // Generic media (e.g. logos, banners, attachments)
  MediaAsset = "media-asset",
  TenantPersonalization = "tenant-personalization",
  TenantContentSettings = "tenant-content-settings",
  Notifications = "notifications",
  NotificationsUnread = "notifications-unread",
  NotificationsUnreadCount = "notifications-unread-count",
  /** Client-side IDs marked read while waiting for server unread queries to sync. */
  NotificationsMarkedRead = "notifications-marked-read",
  EmailTemplates = "email-templates",
  EmailTemplateDefinitions = "email-template-definitions",
  Balance = "balance",
  BalanceSummary = "balance-summary",
  TuitionPreview = "tuition-preview",
  TuitionRatePlans = "tuition-rate-plans",
  CalculationCycles = "calculation-cycles",
  CalculationCycle = "calculation-cycle",
  CalculationCycleCurrent = "calculation-cycle-current",
  CalculationCycleCandidates = "calculation-cycle-candidates",
  Discounts = "discounts",
  Discount = "discount",
  Jobs = "jobs",
  Job = "job",
  JobExecutions = "job-executions",
  TimeClockEntries = "time-clock-entries",
  /** Time entry types (tenant setting): Regular, Private Lesson, Sick Leave, etc. */
  TimeEntryTypes = "time-entry-types",
  /** Accounting / balance reference codes (tenant). */
  TransactionCodes = "transaction-codes",
  /** Approved time entries only (teacher Payroll Hours / historical ledger). */
  PayrollHours = "payroll-hours",
  PrivateLessonsCalendar = "private-lessons-calendar",
  // Teacher portal (mock / teacher-scoped)
  TeacherAvailability = "teacher-availability",
  TeacherClasses = "teacher-classes",
  TeacherClassEnrollments = "teacher-class-enrollments",
  Attendance = "attendance",
  CustomerVaults = "customer-vaults",
  PayJunctionOptions = "payjunction-options",
  Payments = "payments",
  Invoices = "invoices",
  ExternalTerminals = "external-terminals",
  /** Tenant dashboard widget definitions (roles + KPI/Regular). */
  WidgetSettings = "widget-settings",
  /** Tenant dashboard widget aggregate data payloads. */
  WidgetData = "widget-data",
  /** Admin reports catalog from `/api/reports/list`. */
  Reports = "reports",
  MakeupSessions = "makeup-sessions",
  MakeupEligibilitySettings = "makeup-eligibility-settings",
  MakeupExpiryInDays = "makeup-expiry-in-days",
  MakeupAnnualRequestLimit = "makeup-annual-request-limit",
  StudioFeatureSettings = "studio-feature-settings",
  Dances = "dances",
  Choreographers = "choreographers",
  Contractors = "contractors",
  TicketEvents = "ticket-events",
  TicketAdmissions = "ticket-admissions",
  TicketOrders = "ticket-orders",
  TicketPromoCodes = "ticket-promo-codes",
  TicketQuote = "ticket-quote",
  TicketPublicEvent = "ticket-public-event",
  StudioOperationsSettings = "studio-operations-settings",
  StudioSignalsSettings = "studio-signals-settings",
  ClassSchedule = "class-schedule",
  EntityChangeHistory = "entity-change-history",
  EmployeeActivityMonth = "employee-activity-month",
  EmployeeActivityDay = "employee-activity-day",
  TeamActivityToday = "team-activity-today",
  StudioActivityMonth = "studio-activity-month",
  StudioActivityDay = "studio-activity-day",
  StaffOnline = "staff-online",
  UserTasks = "user-tasks",
}
